export default "__VITE_ASSET__Cck0eXyw__"